// TSS vite/03 §"Query keys convention".
// Tuplas, entity-name first. Propuestas de donadora (staging, Q-122) — recurso
// distinto de `donors` (vacas ya promovidas): keys propias.

export const submissionKeys = {
    all:    ['donor-submissions'],
    list:   (filters) => ['donor-submissions', filters],
    detail: (id) => ['donor-submissions', id],
};
